import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLink, useDisplayName, useUserIcon, useSetQrCode, useSetQrCodeLink } from '../state';
import fetchWithToken from '../services';

const CreateQrCode = () => {
    const link = useLink();
    const setQrCode = useSetQrCode();
    const setQrCodeLink = useSetQrCodeLink();
    const displayName = useDisplayName();
    const userIcon = useUserIcon();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const createQrCode = async () => {
            if (isLoading || !link) return;

            setIsLoading(true);
            try {
                const response = await fetchWithToken('/generate-styled-qr-code', {
                    method: 'POST',
                    body: JSON.stringify({
                        link: `${link}?method=qrCode`,
                        backgroundColor: '#68C7CC',
                        showProfile: true,
                        showSupportText: true,
                        text: 'Support'
                    })
                });

                if (response.ok) {
                    console.log('Default styled QR code generated successfully');
                }

                const data = await response.json();

                setQrCode(data.qrCode);
                setQrCodeLink(link);
            } catch (error) {
                console.error('Error generating QR code:', error);
                navigate('/error');
            } finally {
                setIsLoading(false);
            }
        };

        if (link && !isLoading) {
            createQrCode();
        }
    }, [link, setQrCode, setQrCodeLink, navigate, isLoading, displayName, userIcon]);

    return null;
};

export default CreateQrCode;
